import React from 'react';
import { useTheme } from '../../utils/theme-context';

const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex bg-[#F5F5F5] dark:bg-black p-1 rounded-lg w-full shadow-inner">
      <button
        className={`flex items-center min-w-[50%] gap-2 px-4 py-2 rounded-lg transition-colors ${
          theme === 'light' ? 'bg-white text-black' : 'text-gray-500'
        }`}
        onClick={() => setTheme('light')}
      >
        <img
          src={`/assets/navigation-icons/sidebar/${
            theme === 'light' ? 'light-mode.svg' : 'light-mode-disabled.svg'
          }`}
          alt="Light Mode"
          className="w-4 h-4"
        />
        <span>Light</span>
      </button>

      <button
        className={`flex items-center min-w-[50%] gap-2 px-4 py-2 rounded-lg transition-colors ${
          theme === 'dark' ? 'bg-white text-black' : 'text-gray-500'
        }`}
        onClick={() => setTheme('dark')}
      >
        <img
          src={`/assets/navigation-icons/sidebar/${
            theme === 'dark' ? 'dark-mode.svg' : 'dark-mode-disabled.svg'
          }`}
          alt="Dark Mode"
          className="w-4 h-4"
        />
        <span>Dark</span>
      </button>
    </div>
  );
};

export default ThemeToggle;
